import {
  DEFAULT_CONVERSATION_LEVEL,
  DEFAULT_PLANNED_SAMPLE_SIZE,
  quickStudyQuestionCost,
  quickStudyReads,
  studyCreditCost,
} from "@digital-twins/shared-types";
import type { TurnSuggestions } from "@digital-twins/shared-types/assistant";
import type { AudienceSummary } from "@/lib/api";
import { conversationCreditRate } from "@/components/chat/ConversationCreditQuote/ConversationCreditQuote";

/** Pre-instrument minimums from the same effective audience rates and billing functions as launch. */
export function suggestionCreditEstimate(
  suggestion: TurnSuggestions["suggestions"][number],
  audience?: AudienceSummary,
) {
  if (suggestion.kind === "image") return { sampleSize: null, credits: null };
  if (suggestion.kind === "room")
    return {
      sampleSize: null,
      credits:
        typeof audience?.focusGroupCreditsPerMessage === "number" &&
        Number.isFinite(audience.focusGroupCreditsPerMessage) &&
        audience.focusGroupCreditsPerMessage >= 0
          ? conversationCreditRate({
              baseRate: audience.focusGroupCreditsPerMessage,
              level: DEFAULT_CONVERSATION_LEVEL,
              isAdvancedEnabled: false,
            })
          : null,
    };
  const sampleSize =
    suggestion.spec.audience.plannedSampleSize ?? DEFAULT_PLANNED_SAMPLE_SIZE;
  const rate =
    suggestion.kind === "quick_study"
      ? audience?.quickStudyCreditsPerRead
      : audience?.creditsPerRespondent;
  if (typeof rate !== "number" || !Number.isFinite(rate) || rate < 0)
    return { sampleSize, credits: null };
  return {
    sampleSize,
    credits:
      suggestion.kind === "quick_study"
        ? quickStudyQuestionCost(
            audience?.tier ?? "",
            quickStudyReads({ twins: sampleSize }),
            rate,
          )
        : studyCreditCost({
            creditsPerRespondent: rate,
            billableUnits: sampleSize,
          }),
  };
}
